import React, { useEffect } from 'react';
import HeaderNav from '../header-nav/header-nav';
import { Card } from 'src/components';
import { VodacomLogo } from 'src/assets/icons';
import {
  VodapayMax,
  TelkomIcon,
  CellCIcon,
  VodacomIconLight,
  MtnIcon,
  VodaPayKwikaImage,
} from 'src/assets/images/index';
import TealiumEvents from 'src/helpers/tealium-events';
import { contacts } from 'src/common';
import useMerchantProfile from 'src/hooks/useMerchantProfile';
import './products-and-services.scss';

export default function ProductsAndServices() {
  const { merchant } = useMerchantProfile();

  useEffect(() => {
    TealiumEvents.productsAndServices();
  }, []);

  return (
    <section>
      <div className="MyDocuments" data-testid="ProductsAndServices">
        <HeaderNav
          title={merchant?.companyName ? `Hi, welcome ${merchant?.companyName}` : ''}
          screenName="VodaPay Vending"
        >
          <h1 className="page-title has-text-left is-hidden-mobile has-margin-bottom-4">
            VodaPay Vending
          </h1>
          <div className="text-container">
            <VodacomLogo className="image-container"></VodacomLogo>
            <p className="page-description">
              Introducing VodaPay Vending. Now you can offer value-added services for free on your
              VodaPay Max!
            </p>
          </div>
          <div className="text-container">
            <p className="offer-subtitle">
              VodaPay Max, it's more than just a device! Earn extra cash on your card machine by
              selling value-added services such as data, airtime and electricity to your customers.
              With this device, your customers will also be able to pay their EasyPay accounts, DStv
              subscriptions and traffic fines!
            </p>
          </div>
          <div className="card-container">
            <Card className="offer-card bca-card">
              <CardContent title="VodaPay | Max" image={VodapayMax} alt="VodaPay Max" />
            </Card>
            <Card className="offer-card bca-card">
              <CardContent title="VodaPay | Kwika" image={VodaPayKwikaImage} alt="VodaPay Kwika" />
            </Card>
          </div>

          <div className="footer-info-container">
            <p>
              For more details on how to earn commission, please check the reseller section in your
              <span> Kwika</span> and <span>Max</span> Point of Sale Agreement.
            </p>
            <p>Alternatively contact our Merchant Help Desk at {contacts.number} for assistance.</p>
          </div>
        </HeaderNav>
      </div>
    </section>
  );
}
type CardContentProps = {
  title: string;
  image: string;
  alt: string;
};

function CardContent({ title, image, alt }: CardContentProps) {
  return (
    <article className="flex flex-wrap justify-center gap-8 px-0 pt-8 pb-20 md:px-16 md:justify-start">
      <img className="w-30 h-60" src={image} alt={alt} />
      <div>
        <section className="p-4 md:p-0">
          <h2 className="text-2xl text-center text-white md:text-left">{title}</h2>
          <p className="my-4 text-left">
            Offer value-added services to your customers at no extra cost to you, while earning a
            profit!
          </p>
        </section>

        <div className="flex flex-wrap p-8 gap-x-16 gap-y-8 md:p-0">
          <section className="flex flex-col gap-2">
            <h3 className="text-base text-white">Take bill payments on behalf of customers</h3>
            <ul className="ml-4 list-disc">
              <li>DStv subscriptions</li>
              <li>DStv Box Office</li>
              <li>EasyPay Bills</li>
            </ul>
          </section>
          <section className="flex flex-col gap-2">
            <h3 className="text-base text-white">Sell data and airtime</h3>
            <ul className="flex gap-4 p-4 list-none">
              <li>
                <img className="min-w-[2rem] min-h-[2rem]" src={VodacomIconLight} alt="vodacom" />
              </li>
              <li>
                <img className="min-w-[2rem] min-h-[2rem]" src={MtnIcon} alt="mtn" />
              </li>
              <li>
                <img className="min-w-[2rem] min-h-[2rem]" src={TelkomIcon} alt="telkom" />
              </li>
              <li>
                <img className="min-w-[2rem] min-h-[2rem]" src={CellCIcon} alt="cell-c" />
              </li>
            </ul>
            <p className="text-base text-white">
              Sell electricity tokens for hundreds of municipalities!
            </p>
          </section>
        </div>
      </div>
    </article>
  );
}
